/* eslint-disable camelcase */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { krdetailConstants } from "../../../constants/krdetails.constants";
import { getProgressTypeText } from "../../../utils/progressTypeText";

const MeasureText = ({
    interval_type,
    source,
    counting,
    progress_type,
    dsName,
    dsNameShort,
    disp_lower_limit,
    disp_upper_limit,
    metric,
    owner_fullname,
    retainMetric,
    retainText
}: any) => {
    const { t } = useTranslation()
    const survey = (source == 5);
    const intervalType = interval_type ? interval_type.toLowerCase() : '';
    let mText = '';
    if (metric == 2) {
        mText = 'currency$';
    } else if (metric == 3) {
        mText = t('percentage');
    } else {
        mText = t('number');
    }
    const progressTypeText = getProgressTypeText(progress_type, source, counting, t, true);

    let text = `${t('Measured')} ${intervalType} ${t('by')} ${owner_fullname}`;
    if (source == krdetailConstants.SOURCE_WORKSTREAM) {
        text = `${t('Measured')} ${intervalType}`; 
    }
    if (source == krdetailConstants.SOURCE_DATA_STREAMS) {
        text = `${t('Measured')} ${intervalType} ${t('by')} ${t('a datastream')}`;
    }


    let surveyText = `${mText} ${t('with results')} ${progressTypeText}`;
    if (survey && counting != 0) {
        if (counting == 5) {
            surveyText = t('Yes/No survey with results latest update');
        } else {
            surveyText = `
                ${t('scale from')} ${disp_lower_limit} ${t('to')} ${disp_upper_limit}, ${t('where progress reflects the latest update')}
            `;
        }
    }
    const text1 = survey ? ` on a ${surveyText}` : ` ${t('as a')} ${progressTypeText}.`;

    return (
        <div className="kr-measured-text">
            <span role="heading" id="update-kr-measurement-heading" aria-level={2}>{text}
                { source == 10 && dsName && <span>({dsNameShort})</span>}
                {text1}
            </span>
            { retainMetric && 
                <span style={{display: 'inline-block',fontStyle : 'italic', fontSize : '14px', lineHeight : '20xp',fontWeight : 'normal'}}>{retainText}</span>
            }
            
        </div>
    )
}

export default memo(MeasureText);
